<template>
  <div class="score-star">
    <div class="score-star-number">{{ score }}</div>
    <div class="score-star-box">
      <i
        v-for="index in scoreValue"
        :class="getClass(index)"
        :key="index"
      ></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScoreStar',
  props: {
    score: {
      type: [Number, String],
      default: () => 5
    }
  },
  computed: {
    scoreValue() {
      return parseInt(this.score, 10);
    }
  },
  methods: {
    getClass(index) {
      if (this.scoreValue % 1 === 0) {
        return this.scoreValue >= index ? 'active' : '';
      }
      const fullStar = Math.floor(this.scoreValue);
      if (fullStar >= index) {
        return 'active';
      } if (fullStar + 1 === index) {
        return 'half-active';
      }
      return '';
    }
  }
};
</script>

<style lang="less">
.score-star {
  @bg_score: '~assets/images/bg_score.png';
  @icon_star: '~assets/icons/icon_star.svg';
  @icon_star--half: '~assets/icons/icon_star--half.svg';
  @icon_star--active: '~assets/icons/icon_star--active.svg';

  width: 100px;
  height: 106px;
  padding-top: 15px;
  position: relative;
  background: url(@bg_score) center no-repeat;
  background-size: 100% 100%;
  &-number {
    color: @white;
    font-size: 24px;
    line-height: 33px;
    text-align: center;
    font-weight: @font-weight-normal;
  }
  &-box {
    left: 0;
    right: 0;
    top: 43px;
    display: flex;
    position: absolute;
    align-items: center;
    justify-content: center;
    i {
      width: 9px;
      height: 9px;
      background-image: url(@icon_star);
      &.active {
        background-image: url(@icon_star--active);
      }
      &.half-active {
        background-image: url(@icon_star--half);
      }
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>
